import React, { useContext, useState, useEffect, useMemo } from "react";
import { Form, Typography, Checkbox } from "antd";
import CheckListFBYRadioItems from "../../../../../../blocks/FormItems/CheckListFBYRadioItems";
import {
  moreOstomiesOptions,
  ostomiesOptions,
} from "../../../../Options/genExamOptions";
import DynamicInputFields from "../../../../../../blocks/FormItems/DynamicInputFields";
import { checkEmpty } from "../../../../../../helpers/utility";
const { Text } = Typography;
const Ostomies = ({ context, form }) => {
  const { formData } = useContext(context);
  const generalData = formData?.general_examination || formData;
  const initialValues = useMemo(() => generalData, [generalData]);
  const [showOthers, setShowOthers] = useState(
    checkEmpty(initialValues?.ostomies_others) ||
      checkEmpty(initialValues?.examination?.ostomies_others)
  );
  const [checkboxes, setCheckboxes] = useState([]);

  useEffect(() => {
    setShowOthers(
      checkEmpty(initialValues?.ostomies_others) ||
        checkEmpty(initialValues?.examination?.ostomies_others)
    );
  }, [initialValues]);

  useEffect(() => {
    const initialCheckboxes = ostomiesOptions.reduce((acc, checkbox) => {
      acc[checkbox.value] =
        initialValues?.[checkbox.value] ||
        initialValues?.examination?.[checkbox.value] ||
        false; // Initialize all checkboxes based on initialValues
      return acc;
    }, {});
    setCheckboxes(initialCheckboxes);
  }, [initialValues]);

  return (
    <>
      <Text>Ostomies</Text>

      <CheckListFBYRadioItems
        checkBoxOptions={ostomiesOptions}
        radioOptions={moreOstomiesOptions}
        checkboxes={checkboxes}
        setCheckboxes={setCheckboxes}
        form={form}
      />

      <Form.Item valuePropName="checked" name={"ostomies_others"}>
        <Checkbox onChange={(e) => setShowOthers(e.target.checked)}>
          Others
        </Checkbox>
      </Form.Item>
      {showOthers && (
        <DynamicInputFields
          field_key={"ostomies_others"}
          form={form}
          inputStyle={{ maxWidth: 800 }}
        />
      )}
    </>
  );
};

export default Ostomies;
